import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuthSimple.jsx';

const PublicRoute = ({ children }) => {
  const { isAuthenticated, loading, user } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto" />
          <p className="mt-4 text-gray-600">Chargement...</p>
        </div>
      </div>
    );
  }

  if (isAuthenticated) {
    const dest = user?.role === 'superadmin' ? '/superadmin' : '/admin/tracking';
    return <Navigate to={dest} replace />;
  }

  return children;
};

export default PublicRoute;
